import { useContext } from 'react';
import { useStore } from 'react-redux';

import StarsWidgetContext from '@swf/core/providers/StarsWidgetContext';
import type {
  ExtractDispatchFromModel,
  ExtractSelectFromModel,
  Store,
  WidgetModelConfig
} from '@swf/core/store';

/* eslint-disable @typescript-eslint/no-explicit-any */
export interface WidgetContext<C, M extends WidgetModelConfig<C, any>> {
  widgetConfig: C;
  widgetDispatch: ExtractDispatchFromModel<M>;
  widgetSelect: ExtractSelectFromModel<M>;
  widgetId?: string;
}

export type UseWidget<C, M extends WidgetModelConfig<C, any>> = (
  id?: string
) => WidgetContext<C, M>;

export const useWidget = <C, M extends WidgetModelConfig<C, any>>(
  id?: string
): WidgetContext<C, M> => {
  const { widgetId, widgetConfig } = useContext(StarsWidgetContext) || {};
  const store = useStore() as Store;
  const index = (id || widgetId) as string;
  return {
    widgetConfig: widgetConfig as C,
    widgetDispatch: store.dispatch[index],
    widgetSelect: store.select[index],
    widgetId: index
  };
};
